import { RadioGroup as MuiRadioGroup, RadioGroupProps } from '@mui/material';

export const RadioGroup = (props: RadioGroupProps) => <MuiRadioGroup {...props} />;
